import { random, round2Str } from "../helpers/helpers";
import { aqiMeterRegistry } from "./aqiMeterRegistry";

export const generateAqiIndoorChartYearDemo = ({
                                                   meter_id,
                                                   year,
                                               }) => {
    const meter = aqiMeterRegistry.find(
        (m) => m.meter_id === Number(meter_id)
    );

    if (!meter) {
        return { monthly_energy_data: [], year };
    }

    const { ranges } = meter;

    const now = new Date();
    const isCurrentYear = now.getFullYear() === Number(year);
    const lastMonth = isCurrentYear ? now.getMonth() + 1 : 12;

    // Base values for smooth yearly trend
    let baseTemp = random(ranges.temperature[0], ranges.temperature[1]);
    let baseHum = random(ranges.humidity[0], ranges.humidity[1]);
    let baseCo = random(ranges.co[0] * 0.5, ranges.co[0] * 0.8);
    let basePm2 = random(ranges.pm2[0], ranges.pm2[1]);
    let basePm10 = random(ranges.pm10[0], ranges.pm10[1]);

    const monthly_energy_data = [];

    for (let month = 1; month <= lastMonth; month++) {
        // Smooth drift month-to-month
        baseTemp += random(-0.4, 0.4);
        baseHum += random(-2.0, 2.0);
        baseCo += random(-150, 250);
        basePm2 += random(-5, 5);    
        basePm10 += random(-10, 10); 
        
        // Clamp within allowed range
        baseTemp = Math.min(
            Math.max(baseTemp, ranges.temperature[0]),
            ranges.temperature[1]
        );
        baseHum = Math.min(
            Math.max(baseHum, ranges.humidity[0]),
            ranges.humidity[1]
        );
        baseCo = Math.min(
            Math.max(baseCo, ranges.co[0]),
            ranges.co[1]
        );
        basePm2 = Math.min(Math.max(basePm2, ranges.pm2[0]), ranges.pm2[1]);
        basePm10 = Math.min(Math.max(basePm10, ranges.pm10[0]), ranges.pm10[1]);

        const minTemp = baseTemp - random(0.8, 1.8);
        const maxTemp = baseTemp + random(0.8, 2.0);

        const minHum = baseHum - random(5, 10);
        const maxHum = baseHum + random(5, 12);

        const minCo = Math.max(
            0,
            baseCo - random(200, 600)
        );
        const maxCo = baseCo + random(400, 1200);
        const minPm2 = Math.max(0, basePm2 - random(5, 15));
        const maxPm2 = basePm2 + random(5, 15);

        const minPm10 = Math.max(0, basePm10 - random(10, 25));
        const maxPm10 = basePm10 + random(10, 25);

        monthly_energy_data.push({
            month,

            avg_temp: round2Str(baseTemp),
            min_temp: round2Str(minTemp),
            max_temp: round2Str(maxTemp),

            avg_humidity: round2Str(baseHum),
            min_humidity: round2Str(minHum),
            max_humidity: round2Str(maxHum),

            avg_co: round2Str(baseCo),
            min_co: round2Str(minCo),
            max_co: round2Str(maxCo),

            avg_tvoc: round2Str(0),
            min_tvoc: round2Str(0),
            max_tvoc: round2Str(0),

            avg_formaldehyde: round2Str(0),
            min_formaldehyde: round2Str(0),
            max_formaldehyde: round2Str(0),

            avg_pm2: round2Str(basePm2),
            min_pm2: round2Str(minPm2),
            max_pm2: round2Str(maxPm2),

            avg_pm10: round2Str(basePm10),
            min_pm10: round2Str(minPm10),
            max_pm10: round2Str(maxPm10),
        });
    }

    return {
        monthly_energy_data,
        year: Number(year),
    };
};
